const newsletter = `
# eBL Newsletter 5

## 9 July 2021

### Fragmentarium

#### Bibliographical References

- We added “Translation” as a new category to typify bibliographical references.

#### Joins

- Joins are now systematically registered based on the BM join book and the
  data compiled and kindly provided by Jeremiah Peterson for the tablets kept at
  Philadelphia. Tablets in the Fragmentarium can now only be transliterated under
  the lowest join number. To add joins please email us.

### Corpus

#### New Genres

- The Corpus has been extended and now includes other genres besides Literature.
  For now, we added Divination and Lexicography. Should you wish to add
  Categories, Compositions, or Chapters, please email us. Should you wish to
  read up on the underlying conceptual structure of the Corpus module, visit our
  [Wiki on GitHub](<https://github.com/ElectronicBabylonianLiterature/generic-documentation/wiki/Editorial-conventions-(Corpus)#2-editing-with-ebl>).

#### Introduction

- It is now possible to add introductions to text editions. To add your
  introduction please send us your text in markdown formatting and provide a list
  of bibliographical references. If you have never used markdown to provide
  formatting information the [markdown cheatsheet on GitHub](https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet)
  can be a valuable resource.

#### Unplaced Lines

- Lines from manuscripts that cannot be safely placed in the edition of a chapter
  can now be transliterated in the List of Manuscripts. The conventions that you
  are already familiar with from the edition of colophons apply.`

export default newsletter
